import { css } from '@emotion/css';
import { withBasicStyles } from '@/styles/common';

const useStyles = withBasicStyles(() => ({
  // 静态样式
  wrapper: css`
    width: '100vw';
    height: '100vh';
    backgroundColor: rgb(240, 242, 245);
    display: flex;
  `,
}));

export default useStyles;
